import { render, staticRenderFns } from "./Vocab.vue?vue&type=template&id=55acf253&scoped=true&"
import script from "./Vocab.vue?vue&type=script&lang=js&"
export * from "./Vocab.vue?vue&type=script&lang=js&"
import style0 from "./Vocab.vue?vue&type=style&index=0&id=55acf253&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55acf253",
  null
  
)

export default component.exports